module.exports = __webpack_public_path__ + "img/pr-11.5b7c8ae6.png";